<template>
  <div class="host-service-file">
    
    <div class="content">
      <p>线上市场增值服务详情文件</p>
      <div class="content-upload">
        <Upload
          ref="upload"
          :show-upload-list="false"
          :default-file-list="defaultList"
          :on-success="handleSuccess"
          :format="['jpg','jpeg','png','pdf','xls','xlsx','ppt','pptx','doc','docx']"
          :max-size="51200"
          :headers="formHeaders"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize"
          :before-upload="handleBeforeUpload"
          multiple
          type="drag"
          :action="uploadUrl"
          style="display: inline-block;"
        >
          <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
            <div style="font-size:25px">
              +
              <p style="font-size:14px">上传文件</p>
            </div>
          </div>
        </Upload>
        <div
          v-for="(item, index) in uploadList"
          :key="'upload' + index"
          class="upload-show"
        >
          <template v-if="item.status === 'finished'">
            <div class="nameBox">
              <p>{{onlineFileName}}</p>
              <span @click="handleRemove(item)">删除</span>
            </div>
          </template>
          <template v-else>
            <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
              <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
            </Spin>
          </template>
        </div>
      </div>

      <p>线下市场增值服务详情文件</p>
      <div class="content-upload">
        <Upload
          ref="upload2"
          :show-upload-list="false"
          :default-file-list="defaultList2"
          :on-success="handleSuccess2"
          :format="['jpg','jpeg','png','pdf','xls','xlsx','ppt','pptx','doc','docx']"
          :max-size="51200"
          :headers="formHeaders"
          :on-format-error="handleFormatError2"
          :on-exceeded-size="handleMaxSize2"
          :before-upload="handleBeforeUpload2"
          multiple
          type="drag"
          :action="uploadUrl"
          style="display: inline-block;"
        >
          <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
            <div style="font-size:25px">
              +
              <p style="font-size:14px">上传文件</p>
            </div>
          </div>
        </Upload>
        <div
          v-for="(item, index) in uploadList2"
          :key="'upload' + index"
          class="upload-show"
        >
          <template v-if="item.status === 'finished'">
            <div class="nameBox">
              <p>{{onlineFileName2}}</p>
              <span @click="handleRemove2(item)">删除</span>
            </div>
          </template>
          <template v-else>
            <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
              <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
            </Spin>
          </template>
        </div>
      </div>

      <div class="content-btn">
        <Button type="primary" @click="save">保存</Button>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import adHomeEdit from "./ad-home-edit.vue";

export default {
  name: "host-service-file",
  data() {
    return {
      uploadList: [],
      defaultList: [],
      onlineFileName: "",

      uploadList2: [],
      defaultList2: [],
      onlineFileName2: "",
      file: null,
      file2: null,
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl2",
      formHeaders: "getFormHeaders",
    }),
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  methods: {
    ...mapActions({
      getServiceByName: "hostCommonModule/getServiceByName",
      addService: "hostCommonModule/addService",
      putService: "hostCommonModule/putService",
    }),
    async init() {
      let file = await this.getServiceByName({
        ExhibitionId: this.exhibitionInfo.id,
        Name: "线上市场增值服务详情文件"
      });
      if (file && file !== "No Content") {
        this.onlineFileName = file.nameFile;
        this.uploadList = [{
          status: "finished",
          percentage: 100,
          url: file.downloadLink
        }];
        this.file = file;
      }

      let file2 = await this.getServiceByName({
        ExhibitionId: this.exhibitionInfo.id,
        Name: "线下市场增值服务详情文件"
      });
      if (file2 && file2 !== "No Content") {
        this.onlineFileName2 = file2.nameFile;
        this.uploadList2 = [{
          status: "finished",
          percentage: 100,
          url: file2.downloadLink
        }];
        this.file2 = file2;
      }
    },
    // 移除上传图片
    handleRemove(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    // 上传成功
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    // 文件格式错误
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请重新上传！`);
    },
    // 文件过大
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于50M的文件`);
    },
    // 上传数量
    handleBeforeUpload(e) {
      if (e) {
        this.onlineFileName = e.name;
      }
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}份文件`);
      }
      return check;
    },
     // 移除上传图片
    handleRemove2(file) {
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
    },
    // 上传成功
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2 = this.$refs.upload2.fileList;
      }
    },
    // 文件格式错误
    handleFormatError2(file) {
      this.$Message.warning(`文件格式是不正确的, 请重新上传！`);
    },
    // 文件过大
    handleMaxSize2(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于50M的文件`);
    },
    // 上传数量
    handleBeforeUpload2(e) {
      if (e) {
        this.onlineFileName2 = e.name;
      }
      const limitNum = 1;
      const check = this.uploadList2.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}份文件`);
      }
      return check;
    },
    async save() {
      if (this.uploadList.length == 0) {
        this.$Message.warning("请上传线上市场增值服务详情文件");
        return;
      }
      if (this.uploadList2 == 0) {
        this.$Message.warning("请上传线下市场增值服务详情文件");
        return;
      }
      let result = true;
      if (!this.file) {
        let bool = await this.addService({
          ExhibitionId: this.exhibitionInfo.id,
          Name: "线上市场增值服务详情文件",
          NameFile: this.onlineFileName,
          Downloadlink: this.uploadList[0].url
        })
        if (!bool || !bool.successed) {
          result = false;
        }
      } else {
        let bool = await this.putService({
          Id: this.file.id,
          ExhibitionId: this.exhibitionInfo.id,
          Name: "线上市场增值服务详情文件",
          NameFile: this.onlineFileName,
          Downloadlink: this.uploadList[0].url
        })
        if (!bool || !bool.successed) {
          result = false;
        }
      }
      if (!this.file2) {
        let bool = await this.addService({
          ExhibitionId: this.exhibitionInfo.id,
          Name: "线下市场增值服务详情文件",
          NameFile: this.onlineFileName2,
          Downloadlink: this.uploadList2[0].url
        })
        if (!bool || !bool.successed) {
          result = false;
        }
      } else {
        let bool = await this.putService({
          Id: this.file2.id,
          ExhibitionId: this.exhibitionInfo.id,
          NameFile: this.onlineFileName2,
          Name: "线下市场增值服务详情文件",
          Downloadlink: this.uploadList2[0].url
        })
        if (!bool || !bool.successed) {
          result = false;
        }
      }
      if (result) {
        this.$Message.success("保存成功！");
      } else {
        this.$Message.warning("保存失败，请重试！");
      }
      this.onlineFileName = "";
      this.onlineFileName2 = "";
      this.uploadList = [];
      this.uploadList2 = [];
      this.file = null;
      this.file2 = null;
      this.init();
    }
  },
  created() {
    this.init();
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
.host-service-file{
  min-width: 600px;
  padding: 30px 30px 100px 30px;
  .content {
    background-color: #fff;
    padding: 30px 50px;
    color: #333;
    &-upload {
      padding: 10px 30px 30px 100px;
      .upload-show {
        margin-top: 10px;
        .nameBox {
          display: flex;
          align-items: center;
          span {
            margin-left: 10px;
            color: #1890ff;
            cursor: pointer;
            margin-top: 2px;
          }
        }
      }
    }
  }
  .content-btn {
    padding-left: 100px;
    button {
      width: 150px;
      height: 40px;
    }
  }
}
.demo-spin-icon-load{
  animation: ani-demo-spin 1s linear infinite;
}
</style>